<script setup>
import MainLayout from "~/layouts/MainLayout.vue";
import { onMounted } from "vue";
import { useProjectsStore } from "@/stores/projects";
import { ref } from "vue";

const projectsStore = useProjectsStore();
function submitComment() {
  console.log("Comment submitted:", comment.value);
  comment.value = "";
}

const session = ref(null);
const provider = ref("");
const comment = ref("");
const comments = ref([]);

function handleSignIn() {
  if (provider.value === "github" || provider.value === "google") {
    signIn(provider.value);
  }
}

function signIn(providerName) {
  session.value = {
    user: {
      name: providerName === "github" ? "GitHub User" : "Google User",
      email: `${providerName}@example.com`,
    },
  };
}

function signOut() {
  session.value = null;
  provider.value = "";
}

// function submitComment() {
//   if (comment.value.trim() === "") return;
//   comments.value.unshift({
//     name: session.value.user.name,
//     message: comment.value,
//   });
//   comment.value = "";
// }
onMounted(() => {
  projectsStore.getProjects();
});
</script>
<template>
  <MainLayout>
    <div class="min-h-auto sm:overflow-hidden sm:block">
      <div
        class="relative sm:absolute overflow-y-auto sm:mt-[0.5em] text-center justify-left sm:w-[70%] md:w-[50%] mx-auto"
      >
        <div
          class="text-base font-mono text-[#baab8f] justify-center sm:text-md md:text-base lg:text-md"
        >
          <div class="sm:px-2 text-md sm:text-sm align-center">
            I am a proud Rwandan and a self-taught Web, API, and Automation
            Engineer with a strong foundation in backend and frontend
            development, API design, systems integration, and process
            automation.

            <span
              ><NuxtLink
                class="text-[#776849] hover:text-[#776849] hover:underline"
                to="about"
                >Read More</NuxtLink
              ></span
            >
          </div>
          <div class="sm:px-2 py-6 sm:py-4 text-md sm:text-sm align-center">
            I'm Danny IRUMVA, one of the best web developers based in Kigali,
            Rwanda. Still doubting? Just take a look at my work below and see
            for yourself.
          </div>
        </div>
        <div class="mt-2 h-[12em] overflow-x-auto">
          <div class="flex space-x-4 sm:px-2 scrollbar-hide">
            <div
              v-for="project in projectsStore.projects"
              :key="project.id"
              class="flex-none w-32 border border-[#575041] h-[10em] rounded-lg overflow-hidden hover:shadow-md transition-shadow duration-300"
              @click="selectProject(project.id)"
            >
              <NuxtLink
                :to="`/project/${project.id}`"
                class="block text-decoration-none"
                aria-label="View project details for {{ project.name }}"
              >
                <div class="flex justify-center bg-gray-100">
                  <NuxtImg
                    :src="project.image"
                    alt="Project Image"
                    class="w-full h-32 object-cover filter grayscale sepia hue-rotate-180 brightness-75 transition-all duration-300 hover:filter-none"
                  />
                </div>
                <div class="flex justify-center bg-[#776849]">
                  <span class="text-[#0e0d0d] text-center">
                    {{ project.name }}
                  </span>
                </div>
              </NuxtLink>
            </div>
          </div>
        </div>
      </div>
      <div class="relative sm:w-[45%] sm:ml-[33em] mt-2 sm:mt-0">
        <div class="bg-[#0e0d0d] p-4 py-6 rounded-lg shadow-md h-auto">
          <p class="mb-4 text-[#baab8f]">
            Feel free to leave a comment below. You can sign in using your
            GitHub or Google account.
          </p>

          <div v-if="!session" class="border-t border-[#776849] pt-4">
            <select
              v-model="provider"
              @change="handleSignIn"
              class="bg-[#776849] text-white px-2 py-1 float-right -mt-4"
            >
              <option value="" selected>Sign in</option>
              <option value="github">GitHub</option>
              <option value="google">Google</option>
            </select>
          </div>

          <div v-else class="mb-6">
            <p class="mb-2 text-white">Welcome, {{ session.user.name }}!</p>
            <button
              @click="signOut"
              class="bg-gray-800 text-white px-4 py-2 rounded mb-4"
            >
              Sign Out
            </button>

            <form @submit.prevent="submitComment" class="mb-8">
              <textarea
                v-model="comment"
                class="w-full rounded-lg border border-[#575041] bg-[#0e0d0d] px-4 py-3 text-[#baab8f] placeholder-[#776849] focus:border-[#776849] focus:ring-2 focus:ring-[#776849]"
                placeholder="Share your thoughts..."
                rows="4"
              ></textarea>
              <button
                type="submit"
                class="mt-4 w-full rounded-lg bg-[#776849] px-6 py-3 font-medium text-white transition-colors hover:bg-[#9c8a6b]"
              >
                Post Comment
              </button>
            </form>
          </div>

          <div
            v-if="comments.length"
            class="mt-4 border-t border-[#776849] pt-4"
          >
            <h3 class="text-[#baab8f] mb-2">Recent Comments</h3>
            <div
              v-for="(item, index) in comments"
              :key="index"
              class="bg-[#1a1a1a] p-3 rounded mb-2"
            >
              <p class="text-white font-semibold">{{ item.name }}</p>
              <p class="text-[#baab8f]">{{ item.message }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </MainLayout>
</template>
<style scoped>
.font-mono {
  font-family: "Courier New", Courier, monospace;
  text-align: left;
}

h1.font-title {
  font-family: "Anton SC", sans-serif;
  font-weight: bold;
  font-size: 60px;
}

@media (min-width: 640px) {
  .mt-10 {
    margin-top: 10em;
  }
}
</style>
